"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var json_1 = require("../helpers/json");
var SchoolsModel = /** @class */ (function () {
    function SchoolsModel($http, APPURL) {
        var _this = this;
        this.addAdhocPickupLocation = function (data) {
            return _this.$http
                .post(_this.URLS.FETCH + "/" + data.school_id + "/ad-hoc-pickup-locations", {
                location: data,
            })
                .then(_this.cacheResults);
        };
        this.updateAdhocPickupLocation = function (school_id, location_id, data) {
            return _this.$http
                .put(_this.URLS.FETCH +
                "/" +
                school_id +
                "/ad-hoc-pickup-locations/" +
                location_id, data)
                .then(_this.cacheResults);
        };
        this.getAdhocPickupLocations = function (school_id, params) {
            if (params === void 0) { params = {}; }
            if (!params) {
                return _this.$http
                    .get(_this.URLS.FETCH + "/" + school_id + "/ad-hoc-pickup-locations")
                    .then(_this.cacheResults);
            }
            return _this.$http
                .get(_this.URLS.FETCH +
                "/" +
                school_id +
                "/ad-hoc-pickup-locations?" +
                (0, queryString_1.toQueryString)(params))
                .then(_this.cacheResults);
        };
        this.removeAddhocPickupLocation = function (data) {
            return _this.$http
                .delete(_this.URLS.FETCH +
                "/" +
                data.school_id +
                "/ad-hoc-pickup-locations/" +
                data.location_id)
                .then(_this.cacheResults);
        };
        /**
         * @wip
         */
        this.getBillingEmails = function (school_id) {
            return _this.$http
                .get(_this.URLS.FETCH +
                "/" +
                school_id +
                "/billing/school-billing-notification-recipients")
                .then(_this.cacheResults);
        };
        /**
         * @wip
         */
        this.updateBillingEmails = function (school_id, emails) {
            return _this.$http
                .put(_this.URLS.FETCH +
                "/" +
                school_id +
                "/billing/school-billing-notification-recipients", emails)
                .then(_this.cacheResults);
        };
        this.getWebsites = function (school_id) {
            return _this.$http
                .get(_this.URLS.FETCH + "/" + school_id + "/websites")
                .then(_this.cacheResults);
        };
        this.addWebsite = function (school_id, data) {
            return _this.$http
                .post(_this.URLS.FETCH + "/" + school_id + "/websites", data)
                .then(_this.cacheResults);
        };
        this.updateWebsite = function (school_id, website_id, data) {
            return _this.$http
                .put(_this.URLS.FETCH + "/" + school_id + "/websites/" + website_id, data)
                .then(_this.cacheResults);
        };
        this.removeWebsite = function (school_id, website_id) {
            return _this.$http
                .delete(_this.URLS.FETCH + "/" + school_id + "/websites/" + website_id)
                .then(_this.cacheResults);
        };
        this.$http = $http;
        this.URLS = {
            BASE: APPURL + "/api/v1",
            FETCH: APPURL + "/api/v1/schools",
            UPDATE: APPURL + "/api/v1/schools",
            CREATE: APPURL + "/api/v1/schools",
        };
        this.data = [];
        this.school = {};
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
        this.cacheSchool = this.cacheSchool.bind(this);
    }
    SchoolsModel.prototype.extract = function (result) {
        return result.data;
    };
    SchoolsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    SchoolsModel.prototype.cacheSchool = function (result) {
        this.school = this.extract(result);
        var rawAddress = this.school.address;
        this.school.address =
            typeof rawAddress === "string" && (0, json_1.isJson)(rawAddress)
                ? JSON.parse(rawAddress)
                : this.school.address;
        // Normalize locations to ensure zones and zoneparts always exist as arrays
        if (this.school.locations) {
            this.school.locations = this.school.locations.map(function (location) { return (__assign(__assign({}, location), { zones: location.zones || [], zoneparts: location.zoneparts || [] })); });
        }
        return this.school;
    };
    SchoolsModel.prototype.getSchoolByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheSchool);
    };
    SchoolsModel.prototype.getMap = function (id, data) {
        if (data.student_id) {
            return this.$http
                .get(this.URLS.FETCH + "/" + id + "/map?" + (0, queryString_1.toQueryString)(data))
                .then(function (response) {
                return response.data;
            });
        }
        return this.$http
            .get(this.URLS.FETCH + "/map")
            .then(function (response) {
            return response.data;
        });
    };
    SchoolsModel.prototype.getInstructorServiceAreaMap = function (schoolId) {
        return this.$http
            .get(this.URLS.FETCH + "/" + schoolId + "/instructor-service-area-map")
            .then(function (response) {
            return response.data;
        });
    };
    SchoolsModel.prototype.getSchools = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.createSchool = function (school) {
        return this.$http
            .post(this.URLS.CREATE, school)
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getSchoolByCode = function (code) {
        return this.$http
            .post(this.URLS.FETCH + "/code/" + code, {})
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getSchoolPlan = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/plan")
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getPaymentMethods = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/payment-methods")
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.addPaymentMethod = function (id, data) {
        return this.$http
            .post(this.URLS.FETCH + "/" + id + "/payment-methods", data)
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getPaymentMethodIntent = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/payment-methods/intent")
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getSchoolCharges = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/charges")
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getSchoolInvoices = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/invoices")
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.cancelSubscription = function (id) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + id + "/subscriptions")
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.verifyUniqueCode = function (code) {
        return this.$http
            .post(this.URLS.FETCH + "/unique/code", {
            code: code,
        })
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.editSchool = function (school) {
        return this.$http
            .put(this.URLS.CREATE + "/" + school.id, school)
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getTasks = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/tasks")
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.addTask = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/" + data.school_id + "/tasks", data)
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.updateTasks = function (data) {
        return this.$http
            .put(this.URLS.FETCH + "/" + data.school_id + "/tasks", data)
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getHighSchools = function (data) {
        return this.$http
            .post(this.URLS.BASE + "/highschools/find", { location: data })
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.previewServiceAreaForLocation = function (data) {
        return this.$http
            .get(this.URLS.BASE + "/preview-service-area?" + (0, queryString_1.toQueryString)(data))
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.getPickupLocations = function (school_id, params) {
        if (params === void 0) { params = {}; }
        if (!params) {
            return this.$http
                .get(this.URLS.FETCH + "/" + school_id + "/pickuplocations")
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH +
            "/" +
            school_id +
            "/pickuplocations?" +
            (0, queryString_1.toQueryString)(params))
            .then(this.cacheResults);
    };
    SchoolsModel.prototype.configureStripeWebhook = function (schoolId) {
        return this.$http
            .post(this.URLS.FETCH + "/" + schoolId + "/billing/stripe/webhook", {})
            .then(this.extract);
    };
    SchoolsModel.prototype.removeStripeWebhook = function (schoolId) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + schoolId + "/billing/stripe/webhook")
            .then(this.extract);
    };
    SchoolsModel.prototype.configureAuthorizeWebhook = function (schoolId, request) {
        return this.$http
            .post(this.URLS.FETCH + "/" + schoolId + "/billing/authorize/webhook", request)
            .then(this.extract);
    };
    SchoolsModel.prototype.removeAuthorizeWebhook = function (schoolId) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + schoolId + "/billing/authorize/webhook")
            .then(this.extract);
    };
    return SchoolsModel;
}());
SchoolsModel.$inject = ["$http", "APPURL"];
exports.default = SchoolsModel;
